import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPrimaryAccount, getAccountData } from '../../utils/sessionUtil';
import { attributesForCSR } from '../../actions/globalActions';
import HoverText from '../../CommonComponents/Info/Tooltip/HeaderTooltip';
import {
	TourContainer_SecNav,
	FixedWidth_SecNavbar,
	TourTextContainer_SecNav,
	OldLink1,
	Seprator
} from './style'
import { recordError } from "../../utils/commonUtil";
import { selectNavBarData } from '../../selectors/globalSelectors';
class SecondaryNavigationByCSR extends Component {

	componentDidMount(){
		const uri = `/donor-portal/api/account/${getPrimaryAccount().userId}/findAccountAttributesForCSR?partyId=${getAccountData().partyId}`
		this.props.attributesForCSR({
			metaData: {
				method: 'GET',
				url: uri
			}
		})
	}

	loadCaseHistory = () => {
		try {
			let dafAccountId = getPrimaryAccount().userId;
			let partyId = getAccountData().partyId;
			if(window.top.frames.topBar){
				let topBarObj = window.top.frames.topBar;
				topBarObj.postMessage({'message':"casegeneration",'dafAccountId':dafAccountId,"partyId":partyId}, process.env.REACT_APP_GEMINI_CSR_URL);
			}
		} catch (error) {
			recordError(error);
		}
  	}

	render() {
		const { NavBarData } = this.props;
		return(
			<TourContainer_SecNav>
				<FixedWidth_SecNavbar>
					<div>
						{ NavBarData && <TourTextContainer_SecNav>
							{ NavBarData.bookOfBusiness == "Yes" && (
									<span data-test="bookOfbusiness">   Book of Business: <b>{NavBarData.bookOfBusiness}</b><Seprator /></span>
								) 
							}
							{ NavBarData.segmentation != null && (
									<span data-test="segmentation">  <b>{NavBarData.segmentation} <Seprator /></b></span>
								) 
							}
							{ NavBarData.accountIdentifier != "Standard" && NavBarData.accountIdentifier && (
									<span data-test="accountIdentifier">  Identifier: <b>{NavBarData.accountIdentifier}<Seprator /></b></span>
								)
							}
							{ NavBarData.feeTemplate != null && (
									<span data-test="feeTemplate"> Fee Template:<b> {NavBarData.feeTemplate} </b></span>
								)
							}
							{ NavBarData.accountIssue && NavBarData.accountIssue == "Yes" && (
									<><Seprator data-test="accountIssue"/><OldLink1 onClick={this.loadCaseHistory}>Account Issue: {NavBarData.accountIssue}</OldLink1></>
								)
							}
							{ NavBarData.accountStatus != "Open" && (
									<span data-test="accountStatus"> <Seprator /> Status: <b>{NavBarData.accountStatus}</b></span>
								)
							}
							{ NavBarData.accountNotes && (
									<HoverText 
										data-test="accountNotes"
										mobile={window.screen.availWidth <= 991 ? true : false}
										mobilePlacement='bottomLeft'
										placement='bottomRight' 
										title={NavBarData.accountNotes} 
										overlayClassName='disabled-header'>
											<span> <Seprator /> Account Notes: <b>Yes</b></span>
									</HoverText>
								)
							}
							{	NavBarData.accessLevel && (NavBarData.accessLevel === "Read Only" || NavBarData.accessLevel === "Read Only + Exchange") && (
									<span> <Seprator data-test="accessLevel"/> Access: <b>{NavBarData.accessLevel}</b></span>
								)
							}
							</TourTextContainer_SecNav>
						}
					</div>
				</FixedWidth_SecNavbar>
			</TourContainer_SecNav>
		)	
	}
}

const mapStateToProps = state => {
	return {
		NavBarData: selectNavBarData(state.toJS())
	}
}

export const mapDispatchToProps = dispatch => ({
	attributesForCSR: data => dispatch(attributesForCSR(data))
})

SecondaryNavigationByCSR.propTypes = {
    NavBarData: PropTypes.shape({
      accessLevel: PropTypes.string,
      accountIdentifier: PropTypes.string,
      accountIssue: PropTypes.string,
      accountNotes: PropTypes.any,
      accountStatus: PropTypes.string,
      bookOfBusiness: PropTypes.string,
      feeTemplate: PropTypes.any,
      noOfOpenCases: PropTypes.any,
      segmentation: PropTypes.any
    }),
  
    getAttributesForCSR: PropTypes.func
  };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SecondaryNavigationByCSR));